import { render, staticRenderFns } from "./Sgcq.vue?vue&type=template&id=76557457&scoped=true"
import script from "./Sgcq.vue?vue&type=script&lang=js"
export * from "./Sgcq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76557457",
  null
  
)

export default component.exports